// extracted by mini-css-extract-plugin
module.exports = {"remarkText":"index_remarkText_2cQGt"};